export class ThreeDSMethodError extends Error {
  constructor() {
    super('Method flow activated');
  }
}
